// noinspection CssOverwrittenProperties

import styled, { css } from 'styled-components';

import YatScrollbar from '@pkg/components/Sections/Profile/Scrollbar';

export const PUBLISH_BAR_HEIGHT = 72;
export const PUBLISH_BAR_HEIGHT_MOBILE = 54;

interface Props {
    $isEdit?: boolean;
    $editingLiquidID?: boolean;
    $isAuthenticated?: boolean;
    $newNavigation?: boolean;
    $isLiquidIDPreview?: boolean;
    $isCurrentUsersProfile?: boolean;
}

export const PrototypePageWrapper = styled.div<Props>`
    width: 100%;
    max-width: 1920px;
    margin: 0 auto;
    height: 100vh;
    height: 100lvh;

    @media (min-width: ${(props) => props.theme.breakpoints.mobile}) {
        height: calc(100vh - 95px);
    }

    ${({ $isEdit }) =>
        $isEdit &&
        css`
            transition-property: background, padding-top;
            transition-duration: ${({ theme }) => theme.transitions.speeds.normal}s;
            transition-timing-function: ${({ theme }) => theme.transitions.easesCss.cubic};

            background: ${({ theme }) => theme.colors.darkBg};

            @media (min-width: ${(props) => props.theme.breakpoints.mobile}) {
                height: 100vh;
            }
        `}

    // For the new navigation, add padding top for the main nav
    ${({ $editingLiquidID, $isAuthenticated, $newNavigation, $isLiquidIDPreview, $isEdit, $isCurrentUsersProfile }) =>
        $newNavigation &&
        $isAuthenticated &&
        !$editingLiquidID &&
        !$isLiquidIDPreview &&
        css`
            // Mobile
            padding-top: ${$isEdit || $isCurrentUsersProfile ? PUBLISH_BAR_HEIGHT_MOBILE : 0}px;

            // Desktop
            @media (min-width: ${(props) => props.theme.breakpoints.mobile}) {
                padding-top: ${$isEdit ? PUBLISH_BAR_HEIGHT : 0}px;
            }
        `}
`;

export const StyledYatScrollbar = styled(YatScrollbar)<Props>`
    ${({ $isEdit }) =>
        $isEdit &&
        css`
            border-radius: 30px 30px 0 0;
        `}
`;

export const ProfileAndGridWrapper = styled.div`
    display: flex;
    flex-direction: column;
    position: relative;
    width: 100%;
    margin: 0 auto;

    @media (min-width: ${({ theme }) => theme.breakpoints.tabletSmall}) {
        flex-direction: row;
        padding-top: 0;
    }
`;

export const EditButtonWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    justify-self: start;
`;

export const MobileHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    position: relative;

    gap: 10px;

    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    padding: 20px 20px;
`;
